module.exports = __webpack_public_path__ + "img/744.2590db79.jpg";